// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"b188d21d","160":"b60edc52","186":"b2673a67","210":"5b9d5a41","369":"24086f81","403":"cd80dc17","417":"04e29ef9","465":"f4980085","536":"b8e08e2b","786":"35d53596","798":"84827a20","963":"5caf5d6b","976":"7ebf7b25"}[chunkId] + ".chunk.js";
};